import React, {useEffect, useRef, useMemo} from 'react';
// REDUX
import { useDispatch, useSelector } from 'react-redux';
import { getInvoiceFiles, uploadInvoice, getProductDetailReport } from '../actions/invoiceFilesActions';
// AG-GRID
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS

// MATERIAL UI
import { IconButton } from '@material-ui/core';
import GetAppOutlined from '@material-ui/icons/GetAppOutlined';
import ArrowForward from '@material-ui/icons/ArrowForward';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import { useHistory } from 'react-router-dom';
import { firebase } from '../firebase/firebaseConfig';


export const InvoicesPage = () => {
  // REDUX
  const invoiceFilesList = useSelector((state) => state.invoiceFiles.invoiceFilesList );
  const fetchInvoices = async(token) => await dispatch(getInvoiceFiles(token));
  const dispatch = useDispatch();

  // AG GRID
  const gridApiRef = useRef(null);
  const getRowStyle = (params) => {
    if (params.data.invoice_discount === 0 && params.data.supplier === 'CORIBA & CORNEJO') {
        return { background: '#F1948A'  };
    } 
};


  const invoiceDataCellRenderer = ({ data }) => {
    const { prefix_invoice, invoice_number } = data;
    return (
      <>
        <IconButton 
          onClick = { 
            async() => { 
              const currentUser = await firebase.auth().currentUser;
              const t = await currentUser.getIdToken();
              if (t) {
                await dispatch(getProductDetailReport(prefix_invoice, invoice_number, 'download', t));
                
              }
              /** Redirect */
              // history.push(`/dashboard/InvoiceDetail/${prefix_invoice}/${invoice_number}`);
            }
          }
          size="small"
        >
          <GetAppOutlined 
              style={{ color: 'blue' }}
          />
        </IconButton>
        <IconButton 
          onClick = { 
            async() => { 
              
              // await dispatch(getProductDetailReport(prefix_invoice, invoice_number));
              /** Redirect */
              history.push(`/dashboard/InvoiceDetail/${prefix_invoice}/${invoice_number}`);
            }
          }
          size="small"
        >
          <ArrowForward 
              style={{ color: 'green' }}
          />
        </IconButton>


      </>
    );
  };

  

  function formatValue(params) {
     const value = params?.value;
        
        if (typeof value === 'number') {
            return value.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        }
    
        return '';
  }

  const columnDefs = useMemo(() => [
    { field: 'supplier', width: 250, headerName:"Provedor" },
    { field: 'invoice_str', width: 120, headerName:"Factura" },
    { 
      field: 'purchase_date', 
      valueFormatter: (params) => {
        if (params.value) {
          const date = new Date(params.value);
          return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear().toString().substr(-2)}`;
        }
        return null;
      },
      width: 150,
      headerName:"Fecha de compra",
      filter: "agDateColumnFilter", 
            filterParams: {
                browserDatePicker: true, // Use browser's date picker for filtering
                // Provide a custom date comparator function
                comparator: function(filterLocalDateAtMidnight, cellValue) {
                    // Convert cell value (date string) to a Date object
                    const cellDate = new Date(cellValue);
                    // Set the time of the cell date to midnight
                    const cellDateAtMidnight = new Date(cellDate.setHours(0, 0, 0, 0));
                    // Compare the dates
                    if (cellDateAtMidnight.getTime() === filterLocalDateAtMidnight.getTime()) {
                        return 0; // Return 0 if cellValue equals the filterLocalDateAtMidnight
                    }
                    return cellDateAtMidnight < filterLocalDateAtMidnight ? -1 : 1; // Compare dates
                }
            }

    },
    { 
      field: 'sub_total',
      headerName:'Total s/d',
      width:120,
      valueFormatter: formatValue
    },
    { 
      field: 'invoice_discount',
      headerName:'Descuento',
      width:110,
      valueFormatter: formatValue
    },
    { field: 'taxes',
      width: 110,
      headerName:'Impuestos', 
      valueFormatter: formatValue

    },
    { field: 'sub_total_final',
      headerName:'Total antes imp', 
      width:150,
      valueFormatter: formatValue
    },
    { field: 'final_total', headerName:'Pago de factura',width:150,       valueFormatter: formatValue
  },
    { 
      field: 'created_at',
      valueFormatter: (params) => {
        if (params.value) {
          const date = new Date(params.value);
          return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear().toString().substr(-2)}`;
        }
        return null;
      },
      width: 150,
      headerName: 'Fecha de creación',
      filter: "agDateColumnFilter" 
    },
    { 
      field: 'updated_at',
      valueFormatter: (params) => {
        if (params.value) {
          const date = new Date(params.value);
          return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear().toString().substr(-2)}`;
        }
        return null;
      },
      headerName: 'Fecha de actualización',
      width: 200,
      filter: "agDateColumnFilter" 
    },
    {
      headerName: 'Actions',
      cellRenderer: invoiceDataCellRenderer, // Use your custom cell renderer here
      cellRendererParams: {
        // Define parameters to pass to your custom cell renderer
        rowData: params => params, // Pass the entire row data
        // You can add more parameters if needed
      },
  
      width: 200, // Adjust the width as needed
      filter: false
    },
    
  ], []);
  const defaultColDef = useMemo(() => ({
    sortable: true, 
    minWidth: 100,
    menuTabs:['filterMenuTab'],
    suppressMenu: true,
    // suppressMenuHide: true,
    unSortIcon: false,
    floatingFilter: true,
    filter: true,
    resizable: true,

  }), []);

  
  // REACT DOM
  const history = useHistory();

  useEffect(async() => {
    const currentUser = await firebase.auth().currentUser;
    const t = await currentUser.getIdToken();
    if (t) {
      fetchInvoices(t);
    }
    const allData = [];
    if (gridApiRef.current) {
      gridApiRef.current.api.forEachNode((node) => {
        allData.push(node.data);
      });
    }
    return allData;
  },[]);
  // File button
  const fileInputRef = useRef(null);
  const handleFileUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileSelect = async(event) => {
    const selectedFiles = event.target.files;
    const formData = new FormData();

    for (const file of selectedFiles) {
      const filename = file.name;
      if (filename.endsWith('.xml') || filename.endsWith('.XML')) {
        formData.append('invoice_xml', file);
      } else if(filename.endsWith('.pdf') || filename.endsWith('.PDF')){
        formData.append('invoice_pdf', file);
      }
      else if(filename.endsWith('.xlsx')){
        formData.append('bar_codes_excel', file);
      }
      
    }
    const currentUser = await firebase.auth().currentUser;
    const t = await currentUser.getIdToken();
    await dispatch(uploadInvoice(formData, t));
    await dispatch(getInvoiceFiles(t));
  }; 
  return (
    <>
      <div className="d-flex justify-content-between">
        <Typography variant="h4">
          Facturas
        </Typography>
        <>
          <input
            ref={fileInputRef}
            id="file-upload"
            type="file"
            multiple
            style={{ display: 'none' }}
            onChange={handleFileSelect}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleFileUploadClick}
          >
            Subir Archivos
          </Button>
        </>
      </div>
      <hr />
      <div id="myGrid" style={{ height: '500px', width: '100%'}} className="ag-theme-alpine">
        <AgGridReact
          onGridReady={(params) => (gridApiRef.current = params)}
          defaultColDef={defaultColDef}
          pagination={true}
          paginationPageSize={200}
          stopEditingWhenCellsLoseFocus={true}
          rowData={invoiceFilesList}
          columnDefs={columnDefs}
          getRowStyle={getRowStyle}
          enableClipboard={true}
                suppressCopySingleCellRanges={false}

        />
      </div>
    </>
  );
};